import { ALERTS_FETCHED, FETCHING_ALERTS_FAILED } from '../constants/types';
import { makeAuthorizedRequest } from '../utilities/rest';

const fetchingAlertsFailed = () => {
  return {
    type: FETCHING_ALERTS_FAILED,
  };
};

const alertsFetched = (alerts) => {
  return {
    type: ALERTS_FETCHED,
    alerts,
  };
};

export const fetchAlerts = (location) => {
  return async (dispatch) => {
    try {
      const id = location.location_id || location.location_attributes.id;
      const type = location.location_type || location.location_attributes.type;
      const query = `?location_id=${encodeURIComponent(id)}&location_type=${encodeURIComponent(type)}`;
      const url = `/api/communication/internal/alert${query}`;

      const response = await makeAuthorizedRequest(url, 'GET', dispatch);
      const alerts = response.alerts;

      dispatch(alertsFetched(alerts));
    } catch (error) {
      fetchingAlertsFailed();
    }
  };
};
